export const BOOKING_URL = 'https://wa.me/message/A6G3G6YTSATCM1'
export const PRICE = '$39.500'
export const PRICE_VALUE = 39500

export const AGENT_PHOTO_URL = 'https://cdn.magicpatterns.com/uploads/cZsN1FuXem9NVUoZ5fohes/1785954805015.jpg'

export const agent = {
  name: 'Juan Ignacio Oliva',
  initials: 'JIO',
  credential: 'Agente FIFA | Director Técnico Licencia PRO ATFA-CONMEBOL',
  specialty: 'Gestión y representación deportiva',
  bio: 'Profesional vinculado al mundo de la gestión y representación de futbolistas, con 10 años de experiencia en el ámbito del fútbol.',
}

export const situations = [
  'Un representante contactó a tu hijo y no sabés qué preguntar.',
  'Otro club quiere incorporarlo y no sabés si conviene cambiar.',
  'Apareció una prueba o una oportunidad en el exterior.',
  'Les presentaron un contrato o una propuesta y no saben qué revisar.',
  'Tu hijo no está teniendo continuidad y están evaluando qué hacer.',
  'No sabés si es el momento adecuado para buscar representación.',
  'Tenés una decisión importante y querés una segunda opinión profesional.',
]

export const callTopics = [
  'Representantes y agentes',
  'Clubes y cambios de club',
  'Pruebas y fichajes',
  'Contratos y propuestas',
  'Oportunidades en el exterior',
  'Desarrollo de la carrera',
  'Cualquier otra situación concreta de su carrera',
]

export const materials = [
  {
    title: 'Método para Padres de Futbolistas',
    description:
      'Guía completa para entender mejor el camino del futbolista y acompañar la carrera de tu hijo tomando mejores decisiones.',
  },
  {
    title: 'Plan de 30 días',
    description: 'Pasos concretos para ordenar y organizar la carrera futbolística de tu hijo.',
  },
  {
    title: 'Checklist Anti-Humo',
    description:
      'Herramienta para analizar propuestas, representantes y situaciones contractuales, y detectar qué revisar antes de avanzar.',
  },
  {
    title: 'Camino al Primer Contrato Profesional',
    description:
      'Protocolo con los aspectos a tener en cuenta para prepararse y avanzar hacia el primer contrato profesional.',
  },
]

export const pillars = [
  { word: 'Analizar', description: 'Entender mejor las propuestas y oportunidades.' },
  { word: 'Decidir', description: 'Contar con más información antes de tomar una decisión.' },
  { word: 'Acompañar', description: 'Tener herramientas para seguir acompañando la carrera.' },
]

export const followUpExamples = [
  'La propuesta de un representante',
  'Un cambio de club',
  'Un contrato',
  'Una oportunidad en el exterior',
]

export const offerItems = [
  'Videollamada personalizada de 30 minutos',
  'Método para Padres de Futbolistas',
  'Plan de 30 días',
  'Checklist Anti-Humo',
  'Camino al Primer Contrato Profesional',
  'Posibilidad de volver a contactar',
]

export const faqs = [
  {
    question: '¿Quién realiza la videollamada?',
    answer:
      'Juan Ignacio Oliva, Agente FIFA y especialista en gestión y representación deportiva. Además es Director Técnico de fútbol con Licencia PRO ATFA-CONMEBOL.',
  },
  {
    question: '¿Qué puedo consultar durante la videollamada?',
    answer:
      'Representantes, clubes, pruebas, fichajes, contratos, oportunidades en el exterior, cambios de club y cualquier situación concreta relacionada con la carrera del futbolista.',
  },
  {
    question: '¿Qué recibo además de la videollamada?',
    answer:
      'El Método para Padres de Futbolistas, el Plan de 30 días, el Checklist Anti-Humo y el Protocolo Camino al Primer Contrato Profesional: +200 páginas en PDF con lo que un padre necesita saber sobre el mundo del fútbol.',
  },
  {
    question: '¿Puedo volver a consultar después?',
    answer:
      'Sí. Si posteriormente surge una situación concreta relacionada con la carrera del futbolista, pueden volver a escribirnos para recibir orientación sobre ese caso específico.',
  },
  {
    question: '¿Cómo se realiza el pago?',
    answer: 'Mediante un link de pago seguro de Mercado Pago.',
  },
]
